import React from 'react'
import { FiInstagram } from "react-icons/fi";
import { Container, Row, Col } from 'reactstrap'
import { useStaticQuery, graphql } from 'gatsby'
import Heading from '../../../components/shared/heading'
import Text from '../../../components/shared/text'
import Image from '../../../components/image'
import { SectionWrap, InstagramWrap, InstagramItem } from './instagram.stc'

const Instagram = ({ headingCSS, textCSS }) => {
	const galleryData = useStaticQuery(graphql`
		query instagramQuery {
			allGalleryJson(limit: 5) {
				nodes {
					image {
						src {
							childImageSharp {
								gatsbyImageData(width: 245, height: 245, placeholder: TRACED_SVG, quality: 100)
							}
						}
						alt
					}
				}
			}
		}	  
	`);

	const photos = galleryData.allGalleryJson.nodes

	return (
		<SectionWrap>
			<Container>
				<Row>
					<Col lg={12}>
						<Heading {...headingCSS}><FiInstagram /> <Text {...textCSS}>Gallery</Text></Heading>
					</Col>
				</Row>
				<Row>
					<Col lg={12}>
						<InstagramWrap>
							{photos && photos.map((photo, i) => (
								<InstagramItem key={`Gallery-${i}`}>
									{photo?.image?.src && (
										<Image src={photo.image.src} alt={photo.image?.alt || "Gallery"} />
									)}
									{/* {photo.node.preview && <a href={photo.node.preview} target="_blank" rel="noopener noreferrer">Preview Link</a>} */}
								</InstagramItem>
							))}
						</InstagramWrap>
					</Col>
				</Row>
			</Container>
		</SectionWrap>
	)
}


Instagram.defaultProps = {
	headingCSS: {
		as: 'h5',
		textTransform: 'uppercase',
		textAlign: 'center',
		lineHeight: 1,
		mb: '40px',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center'
	},
	textCSS: {
		as: 'span',
		pl: '4px'
	}
}

export default Instagram
